// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Heading from "../Heading"
import { classNames } from "../../utils/helpers"
import { serializers } from "../Serializers"
import { PortableText } from "@portabletext/react"

const SectionImageGrid = ({ section }: any) => {
  const { listItems, title, tags } = section
  const content = section?._rawContent

  const pair = tags?.includes("pair")
  const gridCols =
    tags?.find((tag: string) => tag.startsWith("md:grid-cols-")) ||
    "grid-cols-7"

  return (
    <Container
      fullWidthOnMobile={false}
      constrainedToBreakPoint
      className={classNames(pair && "!px-0 py-4")}
    >
      {title && (
        <Heading as="h2" className="text-blue-500 mb-2 lg:mb-6 text-center">
          {title}
        </Heading>
      )}
      {content && (
        <Box
          className={classNames(
            "max-w-[420px] px-4 m-auto [&>p]:mt-4 [&>h4]:font-extrabold"
          )}
        >
          <PortableText value={content} components={serializers} />
        </Box>
      )}
      <Box
        className={classNames(pair && "max-w-[335px] lg:max-w-[505px] mx-auto")}
      >
        <div className={`grid ${gridCols} gap-4`}>
          {" "}
          {/* Adjust the gap value */}
          {/* Adjust the number of columns based on your design */}
          {listItems.map((item: any, idx: any) => (
            <Box
              className="w-200px h-full mx-auto flex flex-col items-center justify-center"
              key={idx}
            >
              <GatsbyImage
                image={item?.Image?.asset?.gatsbyImageData}
                objectFit="contain"
                alt={item?.Image?.asset?.altText || ""}
              />
              <p className="text-center font-extrabold block text-blue-500 mt-2">
                {item.title}
              </p>
            </Box>
          ))}
        </div>
      </Box>
    </Container>
  )
}

export default SectionImageGrid
